import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export function InlineNotice({ tone = "info", title, children, className }) {
  const tones = {
    info: "bg-primary/5 text-foreground border-primary/30",
    warning: "bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))] border-[hsl(var(--warning))]/40",
    destructive: "bg-destructive/5 text-destructive border-destructive/30",
    success: "bg-[hsl(var(--success))]/10 text-[hsl(var(--success))] border-[hsl(var(--success))]/30",
  };
  return (
    <div className={cn("rounded-xl border p-3 flex gap-2 text-sm", tones[tone], className)}>
      <AlertCircle className="h-4 w-4 mt-0.5 shrink-0" />
      <div>
        {title && <div className="font-medium">{title}</div>}
        <div>{children}</div>
      </div>
    </div>
  );
}
